<template>
  <svg :width="`${matOuterWidth}in`" :height="`${matOuterHeight}in`" xmlns="http://www.w3.org/2000/svg" :x="x" :y="y">
    <rect v-if="!isClearFloated" x="0" y="0" :width="matOuterWidth" :height="matOuterHeight" fill="none" stroke="none"/>
    <image v-else :href="clearFloatOverlayUrl" :width="matOuterWidth" :height="matOuterHeight" preserveAspectRatio="none"/>
  </svg>
</template>

<script>

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    matOuterWidth() {
      return this.frameSpec.matOuterSize().width || 0;
    },
    matOuterHeight() {
      return this.frameSpec.matOuterSize().height || 0;
    },
    isClearFloated() {
      return this.frameSpec.isClearFloated();
    },
    clearFloatOverlayUrl() {
      return "https://cdn.framebridge.com/production/page_addition_assets/421/assets/original/clear-float-overlay-042524.png";
    }
  }
};
</script>

<style scoped>
/* No styles needed */
</style>
